import { render } from "./POIpageContent.vue?vue&type=template&id=533db8f3"
import script from "./POIpageContent.vue?vue&type=script&lang=js"
export * from "./POIpageContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__